/**
 * Default info text for PDF / print when `pdfPrintSettings.infoBlock` is absent or empty.
 */
export const PDF_INFO_BLOCK_FIXED =
  "Tento dokument slúži ako vstupenka do areálu. Predložte ho pri vstupe v tlačenej alebo digitálnej forme.";

/**
 * Default display values when API omits optional fields (processed-order view model).
 */

export const PROCESSED_ORDER_MOCK = {
  fallbackOrderCode: "—",

  orderNumber: "—",

  customerLogoUrl:
    "https://placehold.co/280x96/1565c0/ffffff?text=Logo+z%C3%A1kazn%C3%ADka",

  qrCodeValue: "https://dsok.local/placeholder",

  /** Backend `qrCode.image` data URL; null when not provided (no frontend QR). */
  qrCodeImageSrc: null,

  thankYouTitle: "",

  thankYouDescription: "",

  printButtonLabel: "Stiahnuť / Download",

  infoTextBlock: PDF_INFO_BLOCK_FIXED,

  orderCreatedAtDisplay: "—",

  ticketCount: 0,

  /** @type {Array<{ title: string; quantity: number }>} */
  ticketLines: [],

  orderStatusLabel: "—",

  footerText:
    "Ďakujeme, že využívate naše služby. Tešíme sa na vás na podujatí.",

  bottomImageUrl:
    "https://placehold.co/800x280/e3f2fd/1565c0?text=Mapa+are%C3%A1lu+%2F+orient%C3%A1cia",

  screenLogoUrl:
    "https://placehold.co/200x72/1565c0/ffffff?text=Logo+z%C3%A1kazn%C3%ADka",
};
